import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from '../reducers/rootReducer';
import { logger, crashReporter, cookieMiddleware } from './middleware';
import { subscribePoints } from '../../services/pointsChannel.js';
import { setPoints, triggerCoinBounce } from '../actions/pointsActions.js';
import { subscribeCredits } from '../../services/creditsChannel.js';
import { setCredits } from '../actions/creditsActions.js';

// Setup Redux DevTools
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// Create store with middleware
const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(
    thunk,
    logger,
    crashReporter,
    cookieMiddleware
  ))
);

// Subscribe to points published by axios interceptor
subscribePoints((points) => {
  const current = store.getState()?.points?.value ?? 0;
  if (points !== current) {
    store.dispatch(setPoints(points));
    if (points > current) {
      store.dispatch(triggerCoinBounce());
    }
  }
});

// Subscribe to credits published by axios interceptor
subscribeCredits((credits) => {
  const current = store.getState()?.credits?.value ?? 0;
  if (credits !== current) {
    store.dispatch(setCredits(credits));
  }
});

export default store;
